"use strict";
var GRANULARITY = {
    Sunday: '0',
    Monday: '1',
    Tuesday: '2',
    Wednesday: '3',
    Thursday: '4',
    Friday: '5',
    Saturday: '6',
    Daily: '7',
    Weekly_Average: '8',
    Monthly_Average: '9',
};
var DISPLAY_CHARTS = {
    Entities_Status: '0',
    Entities_SType: '1',
    Entities_SType_New: '9',
    Users: '2',
    Directors: '3',
    Directors_New: '7',
    Shareholders: '4',
    Shareholders_New: '8',
    Task: '5',
    Timeline: '6',
};
var JURISDICTIONS = {
    SINGAPORE: "sg",
    MALAYSIA: "my",
    AUSTRALIA: "au",
    HONGKONG: "hk",
    BVI: "vg",
    UNASSIGNED: "00",
    OTHERS: "01",
    ALL: "all",
};
var ANALYTICS_CONSTANTS = {
    GRANULARITY: GRANULARITY,
    DISPLAY_CHARTS: DISPLAY_CHARTS,
    JURISDICTIONS: JURISDICTIONS,
};
module.exports = ANALYTICS_CONSTANTS;
